

// // // import React, { useState, useEffect } from "react";
// // // import {
// // //   TextField,
// // //   Grid,
// // //   Typography,
// // //   Button,
// // //   Paper,
// // //   Box,
// // //   FormControl,
// // //   InputLabel,
// // //   Select,
// // //   MenuItem,
// // // } from "@mui/material";
// // // import { AttachFile } from "@mui/icons-material";
// // // import useDecodedUser from "../../../../../services/hooks/useDecodedUser";
// // // import FormContainer from "../../../../../components/Forms/FormContainer";
// // // import { ExecuteApiToPost, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// // // export default function IssueBuildingPermit() {
// // //   const decodedUser = useDecodedUser();
// // //   const [id, setId] = useState("");
// // //   const [permit_no, setPermitNo] = useState("");
// // //   const [tinNo, setTinNo] = useState("");
// // //   const [upin, setUPIN] = useState("");
// // //   const [owner_id, setOwnerId] = useState("");
// // //   const [requestNumbers, setRequestNumbers] = useState([]);
// // //   const [issued_on, setIssuedOn] = useState("");
// // //   const [starting_date, setStartingDate] = useState("");
// // //   const [finishing_date, setFinishingDate] = useState("");
// // //   const [status, setStatus] = useState("Finished");
// // //   const [description, setDescription] = useState("");
// // //   const [plan_files, setPlanFiles] = useState([]);
// // //   const [responseMessage, setResponseMessage] = useState("");
// // //   const [data, setData] = useState(null);

// // //   useEffect(() => {
// // //     // Fetch request numbers from the API
// // //     GetDataFromApiWithParams('buildingPermits')
// // //       .then((response) => {
// // //         setRequestNumbers(response);
// // //         console.log("OKAYAYAYA", response)
// // //       })
// // //       .catch((error) => console.error("Error fetching request numbers", error));
// // //   }, []);

// // //   const handleSubmit = async (e) => {
    
// // //     e.preventDefault();
// // //     try {
// // //       const response = await ExecuteApiToPost("buildingPermits/update", {
// // //         id,
// // //         permit_no,
// // //         upin,
// // //         owner_id,
// // //         //permit_issued_by: decodedUser && decodedUser.full_name,
// // //         permit_issued_by: decodedUser?.full_name || "", // Safe access here too
// // //         issued_on,
// // //         starting_date,
// // //         finishing_date,
// // //         status,
// // //         description,
// // //         //permit_no,
// // //         plan_files,
// // //       });
// // //       if (response) {
// // //         setResponseMessage("Building Permit Issued successful!");
// // //       } else {
// // //         setResponseMessage("Building Permit Issued failed: " + response);
// // //       }
// // //     } catch (error) {
// // //       setResponseMessage("An error occurred: " + error.message);
// // //       console.log(error);
// // //     }
// // //   };

// // //   const handleKeySubmit = async () => {
// // //     try {
// // //       if (!permit_no) {
// // //         return;
// // //       }
// // //       const responseData = await GetDataFromApiWithParams(`buildingPermits/${permit_no}`);
// // //       setData(responseData);
// // //     } catch (error) {
// // //       console.error("Error fetching data", error);
// // //     }
// // //   };

// // //   return (
// // //     <FormContainer title="Issue Building Permit" onSubmit={handleSubmit}>
// // //       <Box sx={{ flexGrow: 1, padding: 2 }}>
// // //         <Grid container spacing={3}>
// // //           <Grid item xs={12} md={6}>
// // //             <Paper sx={{ padding: 2 }}>
// // //               <Grid container spacing={2}>
// // //                 {/* <Grid item xs={12} md={12}>
// // //                   <TextField
// // //                     name="id"
// // //                     label="Id"
// // //                     value={id}
// // //                     onChange={(e) => setId(e.target.value)}
// // //                     fullWidth={true}
// // //                   />
// // //                 </Grid> */}
// // //                 {console.log("WOWOWOWOW", requestNumbers)}
// // //                 <Grid item xs={12} md={6}>
// // //                   <FormControl fullWidth={true}>
// // //                     <InputLabel>Request Number</InputLabel>
// // //                     <Select
// // //                       value={permit_no}
// // //                       onChange={(e) => setPermitNo(e.target.value)}
// // //                     >
// // //                       {requestNumbers.map((num) => (
// // //                         <MenuItem key={num.id} value={num.id}>
// // //                          Building Permit:-  {num.id}- Agreement Id:- {num.agreement_id}
// // //                         </MenuItem>
// // //                       ))}
// // //                     </Select>
// // //                   </FormControl>
// // //                 </Grid>
// // //                 <Grid item xs={12} md={6}>
// // //                   <Button
// // //                     onClick={handleKeySubmit}
// // //                     variant="contained"
// // //                     fullWidth={true}
// // //                   >
// // //                     {"Fetch Data"}
// // //                   </Button>
// // //                 </Grid>
// // //                 <Grid item xs={12} md={12}>
// // //                   <TextField
// // //                     type="text"
// // //                     id="permit_issued_by"
// // //                     //value={decodedUser.full_name}
// // //                     value={decodedUser?.full_name || ""}  
// // //                     placeholder="Issued By"
// // //                     fullWidth={true}
// // //                     required
// // //                     disabled
// // //                   />
// // //                 </Grid>
// // //                 <Grid item xs={12} md={12}>
// // //                   <TextField
// // //                     label="Issued on"
// // //                     type="date"
// // //                     value={issued_on}
// // //                     onChange={(e) => setIssuedOn(e.target.value)}
// // //                     fullWidth={true}
// // //                     InputLabelProps={{ shrink: true }}
// // //                   />
// // //                 </Grid>
// // //                 <Grid item xs={12} md={6}>
// // //                   <TextField
// // //                     label="Starting Date"
// // //                     type="date"
// // //                     value={starting_date}
// // //                     onChange={(e) => setStartingDate(e.target.value)}
// // //                     fullWidth={true}
// // //                     InputLabelProps={{ shrink: true }}
// // //                   />
// // //                 </Grid>
// // //                 <Grid item xs={12} md={6}>
// // //                   <TextField
// // //                     label="Finishing Date"
// // //                     type="date"
// // //                     value={finishing_date}
// // //                     onChange={(e) => setFinishingDate(e.target.value)}
// // //                     fullWidth={true}
// // //                     InputLabelProps={{ shrink: true }}
// // //                   />
// // //                 </Grid>
// // //                 <Grid item xs={12} md={12}>
// // //                   <TextField
// // //                     type="text"
// // //                     id="status"
// // //                     value={status}
// // //                     onChange={(e) => setStatus(e.target.value)}
// // //                     required
// // //                     fullWidth={true}
// // //                   />
// // //                 </Grid>
// // //                 <Grid item xs={12} md={12}>
// // //                   <FormControl fullWidth={true}>
// // //                     <Button
// // //                       variant="contained"
// // //                       component="label"
// // //                       startIcon={<AttachFile />}
// // //                     >
// // //                       Attach Requests Form
// // //                       <input
// // //                         type="file"
// // //                         accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
// // //                         onChange={(e) => setPlanFiles(e.target.files[0])}
// // //                         style={{ display: "none" }}
// // //                       />
// // //                     </Button>
// // //                   </FormControl>
// // //                 </Grid>
// // //               </Grid>
// // //             </Paper>
// // //           </Grid>
// // //           <Grid item xs={12} md={6}>
// // //             <Paper sx={{ padding: 2 }}>
// // //               {data ? (
// // //                 <>
// // //                   <Typography variant="h5"> <center>Fetched Information</center></Typography>
// // //                   <br></br>
// // //                    <Typography variant="body1">Owners: {data[0].owners}</Typography>
// // //                    <Typography variant="body1">Permit No: {data[0].permit_no || "NA"}</Typography>
// // //                   <Typography variant="body1">TIN No: {data[0].tin_no || "NA"}</Typography>
// // //                   <Typography variant="body1">Parcel No: {data[0].upin || "N/A"}</Typography>
                  
// // //                 </>
// // //               ) : (
// // //                 <Typography variant="body1">No data fetched yet.</Typography>
// // //               )}
// // //             </Paper>
// // //           </Grid>
// // //         </Grid>
// // //       </Box>
// // //       <Grid item xs={12} md={12}>
// // //         <FormControl fullWidth={true}>
// // //           <TextField
// // //             rows={3}
// // //             name="description"
// // //             id="description"
// // //             label="Description"
// // //             value={description}
// // //             onChange={(e) => setDescription(e.target.value)}
// // //           />
// // //         </FormControl>
// // //       </Grid>
// // //       {responseMessage && <p>{responseMessage}</p>}
// // //     </FormContainer>
// // //   );
// // // }

// // import React, { useState, useEffect } from "react";
// // import {
// //   TextField,
// //   Grid,
// //   Typography,
// //   Button,
// //   Paper,
// //   Box,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// // } from "@mui/material";
// // import { AttachFile } from "@mui/icons-material";
// // import useDecodedUser from "../../../../../services/hooks/useDecodedUser";
// // import FormContainer from "../../../../../components/Forms/FormContainer";
// // import { ExecuteApiToPost, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// // export default function IssueBuildingPermit() {
// //   const decodedUser = useDecodedUser();
// //   const [id, setId] = useState("");
// //   const [permit_no, setPermitNo] = useState("");
// //   const [tinNo, setTinNo] = useState("");
// //   const [upin, setUPIN] = useState("");
// //   const [owner_id, setOwnerId] = useState("");
// //   const [requestNumbers, setRequestNumbers] = useState([]);
// //   const [issued_on, setIssuedOn] = useState("");
// //   const [starting_date, setStartingDate] = useState("");
// //   const [finishing_date, setFinishingDate] = useState("");
// //   const [status, setStatus] = useState("Finished");
// //   const [description, setDescription] = useState("");
// //   const [plan_files, setPlanFiles] = useState([]);
// //   const [responseMessage, setResponseMessage] = useState("");
// //   const [data, setData] = useState(null);
// //   const [loading, setLoading] = useState(false);

// //   useEffect(() => {
// //     // Fetch request numbers from the API
// //     setLoading(true);
// //     GetDataFromApiWithParams('buildingPermits')
// //       .then((response) => {
// //         console.log("API Response:", response);
// //         // Ensure we always set an array
// //         if (Array.isArray(response)) {
// //           setRequestNumbers(response);
// //         } else if (response && response.data && Array.isArray(response.data)) {
// //           // Handle wrapped response
// //           setRequestNumbers(response.data);
// //         } else if (response && typeof response === 'object') {
// //           // If it's a single object, wrap it in an array
// //           setRequestNumbers([response]);
// //         } else {
// //           // Default to empty array
// //           setRequestNumbers([]);
// //         }
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching request numbers", error);
// //         setRequestNumbers([]);
// //       })
// //       .finally(() => {
// //         setLoading(false);
// //       });
// //   }, []);

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     try {
// //       const response = await ExecuteApiToPost("buildingPermits/update", {
// //         id,
// //         permit_no,
// //         upin,
// //         owner_id,
// //         permit_issued_by: decodedUser?.full_name || "",
// //         issued_on,
// //         starting_date,
// //         finishing_date,
// //         status,
// //         description,
// //         plan_files,
// //       });
// //       if (response) {
// //         setResponseMessage("Building Permit Issued successful!");
// //       } else {
// //         setResponseMessage("Building Permit Issued failed: " + response);
// //       }
// //     } catch (error) {
// //       setResponseMessage("An error occurred: " + error.message);
// //       console.log(error);
// //     }
// //   };

// //   const handleKeySubmit = async () => {
// //     try {
// //       if (!permit_no) {
// //         return;
// //       }
// //       setLoading(true);
// //       const responseData = await GetDataFromApiWithParams(`buildingPermits/${permit_no}`);
// //       console.log("Fetched permit data:", responseData);
// //       setData(responseData);
      
// //       // Auto-fill dates from the fetched data
// //       if (responseData) {
// //         // Handle both array and object responses
// //         const permitData = Array.isArray(responseData) ? responseData[0] : responseData;
        
// //         if (permitData) {
// //           // Set starting and finishing dates if they exist
// //           if (permitData.starting_date) {
// //             setStartingDate(permitData.starting_date.split('T')[0]);
// //           }
// //           if (permitData.finishing_date) {
// //             setFinishingDate(permitData.finishing_date.split('T')[0]);
// //           }
// //           // Set other fields
// //           if (permitData.upin) setUPIN(permitData.upin);
// //           if (permitData.owner_id) setOwnerId(permitData.owner_id);
// //           if (permitData.tin_no) setTinNo(permitData.tin_no);
// //           if (permitData.id) setId(permitData.id);
// //         }
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Safety check: ensure requestNumbers is an array before rendering
// //   const safeRequestNumbers = Array.isArray(requestNumbers) ? requestNumbers : [];

// //   return (
// //     <FormContainer title="Issue Building Permit" onSubmit={handleSubmit}>
// //       <Box sx={{ flexGrow: 1, padding: 2 }}>
// //         <Grid container spacing={3}>
// //           <Grid item xs={12} md={6}>
// //             <Paper sx={{ padding: 2 }}>
// //               <Grid container spacing={2}>
// //                 <Grid item xs={12} md={6}>
// //                   <FormControl fullWidth={true}>
// //                     <InputLabel>Request Number</InputLabel>
// //                     <Select
// //                       value={permit_no}
// //                       onChange={(e) => setPermitNo(e.target.value)}
// //                       disabled={loading}
// //                     >
// //                       {safeRequestNumbers.length > 0 ? (
// //                         safeRequestNumbers.map((num) => (
// //                           <MenuItem key={num?.id || Math.random()} value={num?.id || ''}>
// //                             {num ? `Building Permit:- ${num.id}- Agreement Id:- ${num.agreement_id}` : 'Loading...'}
// //                           </MenuItem>
// //                         ))
// //                       ) : (
// //                         <MenuItem disabled value="">
// //                           {loading ? "Loading building permits..." : "No building permits available"}
// //                         </MenuItem>
// //                       )}
// //                     </Select>
// //                   </FormControl>
// //                 </Grid>
// //                 <Grid item xs={12} md={6}>
// //                   <Button
// //                     onClick={handleKeySubmit}
// //                     variant="contained"
// //                     fullWidth={true}
// //                     disabled={!permit_no || loading}
// //                   >
// //                     {loading ? "Loading..." : "Fetch Data"}
// //                   </Button>
// //                 </Grid>
// //                 <Grid item xs={12} md={12}>
// //                   <TextField
// //                     type="text"
// //                     id="permit_issued_by"
// //                     value={decodedUser?.full_name || ""}  
// //                     placeholder="Issued By"
// //                     fullWidth={true}
// //                     required
// //                     disabled
// //                   />
// //                 </Grid>
// //                 <Grid item xs={12} md={12}>
// //                   <TextField
// //                     label="Issued on"
// //                     type="date"
// //                     value={issued_on}
// //                     onChange={(e) => setIssuedOn(e.target.value)}
// //                     fullWidth={true}
// //                     InputLabelProps={{ shrink: true }}
// //                   />
// //                 </Grid>
// //                 <Grid item xs={12} md={6}>
// //                   <TextField
// //                     label="Starting Date"
// //                     type="date"
// //                     value={starting_date}
// //                     onChange={(e) => setStartingDate(e.target.value)}
// //                     fullWidth={true}
// //                     InputLabelProps={{ shrink: true }}
// //                   />
// //                 </Grid>
// //                 <Grid item xs={12} md={6}>
// //                   <TextField
// //                     label="Finishing Date"
// //                     type="date"
// //                     value={finishing_date}
// //                     onChange={(e) => setFinishingDate(e.target.value)}
// //                     fullWidth={true}
// //                     InputLabelProps={{ shrink: true }}
// //                   />
// //                 </Grid>
// //                 <Grid item xs={12} md={12}>
// //                   <TextField
// //                     type="text"
// //                     id="status"
// //                     value={status}
// //                     onChange={(e) => setStatus(e.target.value)}
// //                     required
// //                     fullWidth={true}
// //                   />
// //                 </Grid>
// //                 <Grid item xs={12} md={12}>
// //                   <FormControl fullWidth={true}>
// //                     <Button
// //                       variant="contained"
// //                       component="label"
// //                       startIcon={<AttachFile />}
// //                     >
// //                       Attach Requests Form
// //                       <input
// //                         type="file"
// //                         accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
// //                         onChange={(e) => setPlanFiles(e.target.files[0])}
// //                         style={{ display: "none" }}
// //                       />
// //                     </Button>
// //                   </FormControl>
// //                 </Grid>
// //               </Grid>
// //             </Paper>
// //           </Grid>
// //           <Grid item xs={12} md={6}>
// //             <Paper sx={{ padding: 2 }}>
// //               {data ? (
// //                 <>
// //                   <Typography variant="h5" align="center">Fetched Information</Typography>
// //                   <br />
// //                   {Array.isArray(data) ? (
// //                     // Handle array response
// //                     <>
// //                       <Typography variant="body1">Owners: {data[0]?.owners || "N/A"}</Typography>
// //                       <Typography variant="body1">Permit No: {data[0]?.permit_no || "NA"}</Typography>
// //                       <Typography variant="body1">TIN No: {data[0]?.tin_no || "NA"}</Typography>
// //                       <Typography variant="body1">Parcel No: {data[0]?.upin || "N/A"}</Typography>
// //                       <Typography variant="body1">Starting Date: {data[0]?.starting_date ? new Date(data[0].starting_date).toLocaleDateString() : "N/A"}</Typography>
// //                       <Typography variant="body1">Finishing Date: {data[0]?.finishing_date ? new Date(data[0].finishing_date).toLocaleDateString() : "N/A"}</Typography>
// //                     </>
// //                   ) : (
// //                     // Handle object response
// //                     <>
// //                       <Typography variant="body1">Owners: {data?.owners || "N/A"}</Typography>
// //                       <Typography variant="body1">Permit No: {data?.permit_no || "NA"}</Typography>
// //                       <Typography variant="body1">TIN No: {data?.tin_no || "NA"}</Typography>
// //                       <Typography variant="body1">Parcel No: {data?.upin || "N/A"}</Typography>
// //                       <Typography variant="body1">Starting Date: {data?.starting_date ? new Date(data.starting_date).toLocaleDateString() : "N/A"}</Typography>
// //                       <Typography variant="body1">Finishing Date: {data?.finishing_date ? new Date(data.finishing_date).toLocaleDateString() : "N/A"}</Typography>
// //                     </>
// //                   )}
// //                 </>
// //               ) : (
// //                 <Typography variant="body1">No data fetched yet.</Typography>
// //               )}
// //             </Paper>
// //           </Grid>
// //         </Grid>
// //       </Box>
// //       <Grid item xs={12} md={12}>
// //         <FormControl fullWidth={true}>
// //           <TextField
// //             rows={3}
// //             name="description"
// //             id="description"
// //             label="Description"
// //             value={description}
// //             onChange={(e) => setDescription(e.target.value)}
// //           />
// //         </FormControl>
// //       </Grid>
// //       {responseMessage && <p>{responseMessage}</p>}
// //     </FormContainer>
// //   );
// // }

// import React, { useState, useEffect } from "react";
// import {
//   TextField,
//   Grid,
//   Typography,
//   Button,
//   Paper,
//   Box,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { AttachFile } from "@mui/icons-material";
// import useDecodedUser from "../../../../../services/hooks/useDecodedUser";
// import FormContainer from "../../../../../components/Forms/FormContainer";
// import { ExecuteApiToPost, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// export default function IssueBuildingPermit() {
//   const decodedUser = useDecodedUser();
//   const [id, setId] = useState("");
//   const [permit_no, setPermitNo] = useState("");
//   const [tinNo, setTinNo] = useState("");
//   const [upin, setUPIN] = useState("");
//   const [owner_id, setOwnerId] = useState("");
//   const [requestNumbers, setRequestNumbers] = useState([]);
//   const [issued_on, setIssuedOn] = useState("");
//   const [starting_date, setStartingDate] = useState("");
//   const [finishing_date, setFinishingDate] = useState("");
//   const [status, setStatus] = useState("Finished");
//   const [description, setDescription] = useState("");
//   const [plan_files, setPlanFiles] = useState([]);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     // Fetch request numbers from the API
//     GetDataFromApiWithParams('buildingPermits')
//       .then((response) => {
//         setRequestNumbers(response);
//         console.log("OKAYAYAYA", response)
//       })
//       .catch((error) => console.error("Error fetching request numbers", error));
//   }, []);

//   const handleSubmit = async (e) => {
    
//     e.preventDefault();
//     try {
//       const response = await ExecuteApiToPost("buildingPermits/update", {
//         id,
//         permit_no,
//         upin,
//         owner_id,
//         //permit_issued_by: decodedUser && decodedUser.full_name,
//         permit_issued_by: decodedUser?.full_name || "", // Safe access here too
//         issued_on,
//         starting_date,
//         finishing_date,
//         status,
//         description,
//         //permit_no,
//         plan_files,
//       });
//       if (response) {
//         setResponseMessage("Building Permit Issued successful!");
//       } else {
//         setResponseMessage("Building Permit Issued failed: " + response);
//       }
//     } catch (error) {
//       setResponseMessage("An error occurred: " + error.message);
//       console.log(error);
//     }
//   };

//   const handleKeySubmit = async () => {
//     try {
//       if (!permit_no) {
//         return;
//       }
//       const responseData = await GetDataFromApiWithParams(`buildingPermits/${permit_no}`);
//       setData(responseData);
      
//       // 🔥 ONLY CHANGE: Auto-fill starting and finishing dates from the fetched data
//       if (responseData && responseData.length > 0) {
//         const permitData = responseData[0];
//         console.log("CHECKKKKKKKKKKKKKKKKKKKKKKK", permitData)
//         // Set starting date if it exists in the response
//         if (permitData.expected_starting_date) {
//           // Format the date to YYYY-MM-DD for the date input
//           setStartingDate(permitData.expected_starting_date.split('T')[0]);
//         }
        
//         // Set finishing date if it exists in the response
//         if (permitData.expected_finishing_date) {
//           setFinishingDate(permitData.expected_finishing_date.split('T')[0]);
//         }
        
//         // Optional: Also set other fields if you want them auto-filled
//         if (permitData.upin) setUPIN(permitData.upin);
//         if (permitData.owner_id) setOwnerId(permitData.owner_id);
//         if (permitData.tin_no) setTinNo(permitData.tin_no);
//         if (permitData.id) setId(permitData.id);
//       }
//     } catch (error) {
//       console.error("Error fetching data", error);
//     }
//   };

//   return (
//     <FormContainer title="Issue Building Permit" onSubmit={handleSubmit}>
//       <Box sx={{ flexGrow: 1, padding: 2 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Paper sx={{ padding: 2 }}>
//               <Grid container spacing={2}>
//                 {/* <Grid item xs={12} md={12}>
//                   <TextField
//                     name="id"
//                     label="Id"
//                     value={id}
//                     onChange={(e) => setId(e.target.value)}
//                     fullWidth={true}
//                   />
//                 </Grid> */}
//                 {console.log("WOWOWOWOW", requestNumbers)}
//                 <Grid item xs={12} md={6}>
//                   <FormControl fullWidth={true}>
//                     <InputLabel>Request Number</InputLabel>
//                     <Select
//                       value={permit_no}
//                       onChange={(e) => setPermitNo(e.target.value)}
//                     >
//                       {requestNumbers.map((num) => (
//                         <MenuItem key={num.id} value={num.id}>
//                          Building Permit:-  {num.id}- Agreement Id:- {num.agreement_id}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Button
//                     onClick={handleKeySubmit}
//                     variant="contained"
//                     fullWidth={true}
//                   >
//                     {"Fetch Data"}
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     type="text"
//                     id="permit_issued_by"
//                     //value={decodedUser.full_name}
//                     value={decodedUser?.full_name || ""}  
//                     placeholder="Issued By"
//                     fullWidth={true}
//                     required
//                     disabled
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     label="Issued on"
//                     type="date"
//                     value={issued_on}
//                     onChange={(e) => setIssuedOn(e.target.value)}
//                     fullWidth={true}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Starting Date"
//                     type="date"
//                     value={starting_date}
//                     onChange={(e) => setStartingDate(e.target.value)}
//                     fullWidth={true}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Finishing Date"
//                     type="date"
//                     value={finishing_date}
//                     onChange={(e) => setFinishingDate(e.target.value)}
//                     fullWidth={true}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     type="text"
//                     id="status"
//                     value={status}
//                     onChange={(e) => setStatus(e.target.value)}
//                     required
//                     fullWidth={true}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <FormControl fullWidth={true}>
//                     <Button
//                       variant="contained"
//                       component="label"
//                       startIcon={<AttachFile />}
//                     >
//                       Attach Requests Form
//                       <input
//                         type="file"
//                         accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
//                         onChange={(e) => setPlanFiles(e.target.files[0])}
//                         style={{ display: "none" }}
//                       />
//                     </Button>
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Paper sx={{ padding: 2 }}>
//               {data ? (
//                 <>
//                   <Typography variant="h5"> <center>Fetched Information</center></Typography>
//                   <br></br>
//                    <Typography variant="body1">Owners: {data[0].owners}</Typography>
//                    <Typography variant="body1">Permit No: {data[0].permit_no || "NA"}</Typography>
//                   <Typography variant="body1">TIN No: {data[0].tin_no || "NA"}</Typography>
//                   <Typography variant="body1">Parcel No: {data[0].upin || "N/A"}</Typography>
                  
//                 </>
//               ) : (
//                 <Typography variant="body1">No data fetched yet.</Typography>
//               )}
//             </Paper>
//           </Grid>
//         </Grid>
//       </Box>
//       <Grid item xs={12} md={12}>
//         <FormControl fullWidth={true}>
//           <TextField
//             rows={3}
//             name="description"
//             id="description"
//             label="Description"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//           />
//         </FormControl>
//       </Grid>
//       {responseMessage && <p>{responseMessage}</p>}
//     </FormContainer>
//   );
// }

import React, { useState, useEffect } from "react";
import {
  TextField,
  Grid,
  Typography,
  Button,
  Paper,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert
} from "@mui/material";
import { AttachFile, Download, Visibility, Close, PictureAsPdf, Comment } from "@mui/icons-material";
import useDecodedUser from "../../../../../services/hooks/useDecodedUser";
import FormContainer from "../../../../../components/Forms/FormContainer";
import { ExecuteApiToPost, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
import { IPDCToastMessageResult } from "../../../../../components/Controls";
import config from "../../../../../config";
import DetailPlanView from "./DetailPlanView";

export default function IssueBuildingPermit() {
  const decodedUser = useDecodedUser();
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  
  // Original state from code 2
  const [id, setId] = useState("");
  const [permit_no, setPermitNo] = useState("");
  const [tinNo, setTinNo] = useState("");
  const [upin, setUPIN] = useState("");
  const [owner_id, setOwnerId] = useState("");
  const [requestNumbers, setRequestNumbers] = useState([]);
  const [issued_on, setIssuedOn] = useState("");
  const [starting_date, setStartingDate] = useState("");
  const [finishing_date, setFinishingDate] = useState("");
  const [status, setStatus] = useState("Finished");
  const [description, setDescription] = useState("");
  const [plan_files, setPlanFiles] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // New state from code 1 (all elements except building request number dropdown)
  const [commentType, setCommentType] = useState("");
  const [comment, setComment] = useState("");
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState({ type: "info", text: "" });
  const [toastMessage, setToastMessage] = useState({ message: "", type: "" });
  const [showDetail, setShowDetail] = useState(false);
  const [showOthersComment, setShowOthersComment] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [othersComments, setOthersComments] = useState([]);
  const [loadingOthersComments, setLoadingOthersComments] = useState(false);
  
  // State for modal and file info
  const [modalOpen, setModalOpen] = useState(false);
  const [fileInfo, setFileInfo] = useState(null);
  const [fetchingFile, setFetchingFile] = useState(false);
  const [buildingPermitDetails, setBuildingPermitDetails] = useState(null);
  const [availableFiles, setAvailableFiles] = useState([]);

  // Original useEffect from code 2
  useEffect(() => {
    setLoading(true);
    GetDataFromApiWithParams('buildingPermits')
      .then((response) => {
        console.log("API Response:", response);
        if (Array.isArray(response)) {
          setRequestNumbers(response);
        } else if (response && response.data && Array.isArray(response.data)) {
          setRequestNumbers(response.data);
        } else if (response && typeof response === 'object') {
          setRequestNumbers([response]);
        } else {
          setRequestNumbers([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching request numbers", error);
        setRequestNumbers([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Fetch building permit details when request number changes (from code 1)
  useEffect(() => {
    const fetchBuildingPermitDetails = async () => {
      if (permit_no) {
        try {
          setFetchingFile(true);
          let response;
          try {
            response = await GetDataFromApiWithParams(`buildingPermits/${permit_no}/details`);
          } catch (error) {
            response = await GetDataFromApiWithParams(`buildingPermits/${permit_no}`);
          }
          
          if (response) {
            const details = Array.isArray(response) ? response[0] : response;
            setBuildingPermitDetails(details);
            
            // Check available files (only PDF files)
            const files = [];
            
            const isPDF = (path) => {
              return path && path.toLowerCase().endsWith('.pdf');
            };
            
            if (details.plan_archtectural_path && isPDF(details.plan_archtectural_path)) {
              files.push({ type: 'architectural', path: details.plan_archtectural_path });
            }
            if (details.plan_structural_path && isPDF(details.plan_structural_path)) {
              files.push({ type: 'structural', path: details.plan_structural_path });
            }
            if (details.plan_sanitary_path && isPDF(details.plan_sanitary_path)) {
              files.push({ type: 'sanitary', path: details.plan_sanitary_path });
            }
            if (details.plan_electrical_path && isPDF(details.plan_electrical_path)) {
              files.push({ type: 'electrical', path: details.plan_electrical_path });
            }
            if (details.plan_electro_mechanical_path && isPDF(details.plan_electro_mechanical_path)) {
              files.push({ type: 'electro-mechanical', path: details.plan_electro_mechanical_path });
            }
            if (details.plan_environmental_path && isPDF(details.plan_environmental_path)) {
              files.push({ type: 'environmental', path: details.plan_environmental_path });
            }
            if (details.plan_other_path && isPDF(details.plan_other_path)) {
              files.push({ type: 'other', path: details.plan_other_path });
            }
            
            setAvailableFiles(files);
          }
        } catch (error) {
          console.error("Error fetching building permit details:", error);
          setMessage({ type: "error", text: "Error fetching building permit details" });
          setToastMessage({ message: "Error fetching building permit details", type: "error" });
        } finally {
          setFetchingFile(false);
        }
      }
    };

    fetchBuildingPermitDetails();
  }, [permit_no]);

  // Fetch others comments (from code 1)
  useEffect(() => {
    const fetchOthersComments = async () => {
      if (permit_no) {
        try {
          setLoadingOthersComments(true);
          const response = await GetDataFromApiWithParams(`buildingPermits/comment/${permit_no}`);
          
          if (response) {
            let comments = [];
            
            if (Array.isArray(response)) {
              comments = response;
            } else if (response.data && Array.isArray(response.data)) {
              comments = response.data;
            } else if (response.data) {
              comments = [response.data];
            } else if (response.comments) {
              comments = Array.isArray(response.comments) ? response.comments : [response.comments];
            } else {
              comments = [response];
            }
            
            comments = comments.filter(c => c !== null);
            setOthersComments(comments);
          }
        } catch (error) {
          console.error("Error fetching others comments:", error);
          setToastMessage({ 
            message: error.response?.data?.message || "Error fetching others comments", 
            type: "error" 
          });
          setOthersComments([]);
        } finally {
          setLoadingOthersComments(false);
        }
      }
    };
  
    if (showOthersComment) {
      fetchOthersComments();
    }
  }, [permit_no, showOthersComment]);

  // Original handleKeySubmit from code 2
  // Original handleKeySubmit from code 2 - FIXED to properly set the ID
const handleKeySubmit = async () => {
  try {
    if (!permit_no) {
      return;
    }
    setLoading(true);
    const responseData = await GetDataFromApiWithParams(`buildingPermits/${permit_no}`);
    console.log("Fetched permit data:", responseData);
    setData(responseData);
    
    if (responseData && responseData.length > 0) {
      const permitData = responseData[0];
      console.log("Permit data received:", permitData);
      
      // Set the ID - check for different possible ID field names
      // The ID might be in permitData.id or permitData.permit_id
      const permitId = permitData.id || permitData.permit_id || permitData.building_permit_id;
      if (permitId) {
        console.log("Setting ID to:", permitId);
        setId(String(permitId)); // Convert to string to be safe
      } else {
        console.warn("No ID found in permit data. Available keys:", Object.keys(permitData));
      }
      
      // Set starting date if it exists in the response
      if (permitData.expected_starting_date) {
        setStartingDate(permitData.expected_starting_date.split('T')[0]);
      }
      
      // Set finishing date if it exists in the response
      if (permitData.expected_finishing_date) {
        setFinishingDate(permitData.expected_finishing_date.split('T')[0]);
      }
      
      // Optional: Also set other fields if you want them auto-filled
      if (permitData.upin) setUPIN(permitData.upin);
      if (permitData.owner_id) setOwnerId(permitData.owner_id);
      if (permitData.tin_no) setTinNo(permitData.tin_no);
    }
  } catch (error) {
    console.error("Error fetching data", error);
  } finally {
    setLoading(false);
  }
};

  // Original handleSubmit from code 2
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await ExecuteApiToPost("buildingPermits/update", {
        id,
        permit_no,
        upin,
        owner_id,
        permit_issued_by: decodedUser?.full_name || "",
        issued_on,
        starting_date,
        finishing_date,
        status,
        description,
        plan_files,
      });
      if (response) {
        setToastMessage({ 
          message: "✅ Building Permit issued successfully!", 
          type: "success" 
        });
      } else {
        // setResponseMessage("Building Permit Issued failed: " + response);
      }
    } catch (error) {
      setResponseMessage("An error occurred: " + error.message);
      console.log(error);
    }
  };

  // New functions from code 1
  const getFilePath = () => {
    if (!buildingPermitDetails || !commentType) return null;

    const filePathMap = {
      architectural: buildingPermitDetails.plan_archtectural_path,
      sanitary: buildingPermitDetails.plan_sanitary_path,
      structural: buildingPermitDetails.plan_structural_path,
      "electro-mechanical": buildingPermitDetails.plan_electro_mechanical_path,
      electrical: buildingPermitDetails.plan_electrical_path,
      environmental: buildingPermitDetails.plan_environmental_path,
      other: buildingPermitDetails.plan_other_path,
    };

    let filePath = filePathMap[commentType];
    
    if (!filePath || !filePath.toLowerCase().endsWith('.pdf')) {
      return null;
    }
    
    if (filePath.startsWith('uploads/')) {
      filePath = filePath.substring(8);
    }
    if (filePath.startsWith('/uploads/')) {
      filePath = filePath.substring(9);
    }
    
    return filePath;
  };

  const handleDownloadPlan = async () => {
    try {
      if (!commentType || !permit_no) {
        setMessage({ type: "warning", text: "Please select both request number and comment type" });
        setToastMessage({ message: "Please select both request number and comment type", type: "warning" });
        return;
      }

      const filePath = getFilePath();
      
      if (!filePath) {
        const availableTypes = availableFiles.map(f => f.type).join(', ');
        setMessage({ 
          type: "warning", 
          text: `No PDF file found for "${commentType}". Available PDF files: ${availableTypes || 'none'}`
        });
        setToastMessage({ 
          message: `No PDF file found for "${commentType}"`, 
          type: "warning" 
        });
        return;
      }

      const fullUrl = `${config.apiUrl}/uploads/${filePath}`;
      const response = await fetch(fullUrl, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("Authentication failed. Please log in again.");
        }
        throw new Error(`Download failed: ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filePath.split('/').pop());
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      setMessage({ type: "success", text: "Download started" });
      setToastMessage({ message: "Download started", type: "success" });
    } catch (error) {
      console.error("Download error:", error);
      setMessage({ type: "error", text: error.message || "Error downloading file" });
      setToastMessage({ message: error.message || "Error downloading file", type: "error" });
    }
  };

  const handleViewDetailPlan = () => {
    if (!permit_no) {
      setMessage({ type: "warning", text: "Please select a request number first" });
      setToastMessage({ message: "Please select a request number first", type: "warning" });
      return;
    }
    setShowDetail(!showDetail);
    if (showOthersComment) setShowOthersComment(false);
  };

  const handleViewOthersComment = () => {
    if (!permit_no) {
      setMessage({ type: "warning", text: "Please select a request number first" });
      setToastMessage({ message: "Please select a request number first", type: "warning" });
      return;
    }
    setShowOthersComment(!showOthersComment);
    if (showDetail) setShowDetail(false);
  };

  const handleViewPDF = async () => {
    try {
      if (!commentType || !permit_no) {
        setMessage({ type: "warning", text: "Please select both request number and comment type" });
        setToastMessage({ message: "Please select both request number and comment type", type: "warning" });
        return;
      }

      const filePath = getFilePath();
      
      if (!filePath) {
        const availableTypes = availableFiles.map(f => f.type).join(', ');
        setMessage({ 
          type: "warning", 
          text: `No PDF file found for "${commentType}". Available PDF files: ${availableTypes || 'none'}`
        });
        setToastMessage({ 
          message: `No PDF file found for "${commentType}"`, 
          type: "warning" 
        });
        return;
      }

      setFetchingFile(true);
      
      const fullUrl = `${config.apiUrl}/uploads/${filePath}`;
      const response = await fetch(fullUrl, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const fileName = filePath.split('/').pop();
      
      setFileInfo({
        name: fileName,
        blobUrl: blobUrl,
      });
      
      setModalOpen(true);
      setFetchingFile(false);
    } catch (error) {
      console.error("Error viewing PDF:", error);
      setMessage({ type: "error", text: error.message || "Error accessing file" });
      setToastMessage({ message: error.message || "Error accessing file", type: "error" });
      setFetchingFile(false);
    }
  };

  const handleCloseModal = () => {
    if (fileInfo?.blobUrl) {
      URL.revokeObjectURL(fileInfo.blobUrl);
    }
    setModalOpen(false);
    setFileInfo(null);
  };

  const handleSubmitComment = async () => {
    if (!comment.trim()) {
      setMessage({ type: "warning", text: "Please enter a comment" });
      setToastMessage({ message: "Please enter a comment", type: "warning" });
      return;
    }
    
    setSubmitting(true);
    try {
      const responseData = await ExecuteApiToPost(`buildingPermits/${permit_no}/comment`, {
        requestNumber: permit_no,
        commentedBy: decodedUser.full_name,
        commentType,
        comment,
      });
      setMessage({ type: "success", text: responseData.message || "Comment submitted successfully" });
      setToastMessage({ message: responseData.message || "Comment submitted successfully", type: "success" });
      setComment("");
      
      if (showOthersComment) {
        const comments = await GetDataFromApiWithParams(`buildingPermits/${permit_no}/comments`);
        setOthersComments(Array.isArray(comments) ? comments : [comments]);
      }
    } catch (error) {
      setMessage({ type: "error", text: error.message || "Error submitting comment" });
      setToastMessage({ message: error.message || "Error submitting comment", type: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  const renderPDFViewer = () => {
    if (!fileInfo) return null;

    return (
      <iframe
        src={fileInfo.blobUrl}
        width="100%"
        height="100%"
        style={{ 
          border: 'none',
          minHeight: '600px'
        }}
        title="View Plan"
      />
    );
  };

  const renderOthersCommentsTable = () => {
    if (loadingOthersComments) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      );
    }
  
    if (!othersComments || othersComments.length === 0) {
      return (
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body1" color="textSecondary">
            No comments found for this request.
          </Typography>
        </Paper>
      );
    }
  
    const validComments = othersComments.filter(comment => comment !== null);
  
    if (validComments.length === 0) {
      return (
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body1" color="textSecondary">
            No valid comments found.
          </Typography>
        </Paper>
      );
    }
  
    return (
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ color: '#000000', fontWeight: 600, fontFamily: '"Times New Roman", Times, serif'}}>
                Comment Type</TableCell>
              <TableCell sx={{ color: '#000000', fontWeight: 600, fontFamily: '"Times New Roman", Times, serif'}}>
                Comment</TableCell>
              <TableCell sx={{ color: '#000000', fontWeight: 600, fontFamily: '"Times New Roman", Times, serif'}}>
                Commented By</TableCell>
              <TableCell sx={{ color: '#000000', fontWeight: 600, fontFamily: '"Times New Roman", Times, serif'}}>
                Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {validComments.map((comment, index) => (
              <TableRow key={comment?.id || index} hover>
                <TableCell>{comment?.comment_type || 'N/A'}</TableCell>
                <TableCell>{comment?.comment || 'N/A'}</TableCell>
                <TableCell>
                  {comment?.commented_by_name || comment?.commented_by || 'N/A'}
                </TableCell>
                <TableCell>
                  {comment?.date_of_comment 
                    ? new Date(comment.date_of_comment).toLocaleDateString() 
                    : 'N/A'
                  }
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const safeRequestNumbers = Array.isArray(requestNumbers) ? requestNumbers : [];

  return (
    <FormContainer title="Issue Building Permit" onSubmit={handleSubmit}>
      <Box sx={{ flexGrow: 1, padding: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ padding: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth={true}>
                    <InputLabel>Request Number</InputLabel>
                    <Select
                      value={permit_no}
                      onChange={(e) => {
                        setPermitNo(e.target.value);
                        setCommentType("");
                        setShowDetail(false);
                        setShowOthersComment(false);
                      }}
                      disabled={loading}
                    >
                      {safeRequestNumbers.length > 0 ? (
                        safeRequestNumbers.map((num) => (
                          <MenuItem key={num?.id || Math.random()} value={num?.id || ''}>
                            {num ? `Building Permit:- ${num.id}- Agreement Id:- ${num.agreement_id}` : 'Loading...'}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled value="">
                          {loading ? "Loading building permits..." : "No building permits available"}
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Button
                    onClick={handleKeySubmit}
                    variant="contained"
                    fullWidth={true}
                    disabled={!permit_no || loading}
                  >
                    {loading ? "Loading..." : "Fetch Data"}
                  </Button>
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    type="text"
                    id="permit_issued_by"
                    value={decodedUser?.full_name || ""}  
                    placeholder="Issued By"
                    fullWidth={true}
                    required
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label="Issued on"
                    type="date"
                    value={issued_on}
                    onChange={(e) => setIssuedOn(e.target.value)}
                    fullWidth={true}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Starting Date"
                    type="date"
                    value={starting_date}
                    onChange={(e) => setStartingDate(e.target.value)}
                    fullWidth={true}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Finishing Date"
                    type="date"
                    value={finishing_date}
                    onChange={(e) => setFinishingDate(e.target.value)}
                    fullWidth={true}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    type="text"
                    id="status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    required
                    fullWidth={true}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth={true}>
                    <Button
                      variant="contained"
                      component="label"
                      startIcon={<AttachFile />}
                    >
                      Attach Requests Form
                      <input
                        type="file"
                        accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
                        onChange={(e) => setPlanFiles(e.target.files[0])}
                        style={{ display: "none" }}
                      />
                    </Button>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ padding: 2 }}>
              {data ? (
                <>
                  <Typography variant="h5" align="center">Fetched Information</Typography>
                  <br />
                  {Array.isArray(data) ? (
                    <>
                      <Typography variant="body1">Owners: {data[0]?.owners || "N/A"}</Typography>
                      <Typography variant="body1">Permit No: {data[0]?.permit_no || "NA"}</Typography>
                      <Typography variant="body1">TIN No: {data[0]?.tin_no || "NA"}</Typography>
                      <Typography variant="body1">Parcel No: {data[0]?.upin || "N/A"}</Typography>
                    </>
                  ) : (
                    <>
                      <Typography variant="body1">Owners: {data?.owners || "N/A"}</Typography>
                      <Typography variant="body1">Permit No: {data?.permit_no || "NA"}</Typography>
                      <Typography variant="body1">TIN No: {data?.tin_no || "NA"}</Typography>
                      <Typography variant="body1">Parcel No: {data?.upin || "N/A"}</Typography>
                    </>
                  )}
                </>
              ) : (
                <Typography variant="body1">No data fetched yet.</Typography>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>

      

      {/* Response message from code 2 */}
      {responseMessage && <p>{responseMessage}</p>}

      {/* All elements from code 1 added below (except building request number dropdown) */}
      
      {/* Comment Type and Download Section */}
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={9} md={9}>
          <FormControl fullWidth={true}>
            <InputLabel>Comment Type</InputLabel>
            <Select 
              value={commentType} 
              onChange={(e) => setCommentType(e.target.value)} 
              error={!!errors.commentType}
            >
              <MenuItem value="architectural">Architectural</MenuItem>
              <MenuItem value="sanitary">Sanitary</MenuItem>
              <MenuItem value="structural">Structural</MenuItem>
              <MenuItem value="electro-mechanical">Electro-Mechanical</MenuItem>
              <MenuItem value="electrical">Electrical</MenuItem>
              <MenuItem value="environmental">Environmental</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={3} md={3}>
          <Button 
            startIcon={<Download />} 
            onClick={handleDownloadPlan}
            disabled={!permit_no || !commentType || fetchingFile}
            variant="outlined"
            fullWidth
          >
            {fetchingFile ? <CircularProgress size={24} /> : "Download"}
          </Button>
        </Grid>

        {/* Available Files Info */}
        {buildingPermitDetails && availableFiles.length > 0 && (
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2, bgcolor: 'background.default' }}>
              <Typography variant="subtitle2" gutterBottom>
                Available PDF Files for Request #{permit_no}:
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {availableFiles.map((file) => (
                  <Chip
                    key={file.type}
                    label={file.type}
                    size="small"
                    color={file.type === commentType ? "primary" : "default"}
                    variant={file.type === commentType ? "filled" : "outlined"}
                    onClick={() => setCommentType(file.type)}
                    icon={<PictureAsPdf />}
                  />
                ))}
              </Box>
            </Paper>
          </Grid>
        )}

        {/* View Buttons Section */}
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <Button 
              variant="outlined" 
              onClick={handleViewDetailPlan}
              disabled={!permit_no}
              startIcon={<Visibility />}
            >
              {showDetail ? "HIDE PERMIT DETAIL" : "VIEW PERMIT DETAIL"}
            </Button>
            
            <Button 
              variant="outlined" 
              onClick={handleViewOthersComment}
              disabled={!permit_no}
              startIcon={<Comment />}
              color="secondary"
            >
              {showOthersComment ? "HIDE OTHERS COMMENT" : "VIEW OTHERS COMMENT"}
            </Button>
            
            {buildingPermitDetails && commentType && (
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'medium' }}>
                {commentType} - {buildingPermitDetails.agreement_id}
              </Typography>
            )}
            
            <Button 
              variant="contained" 
              onClick={handleViewPDF}
              disabled={!permit_no || !commentType || fetchingFile}
              startIcon={<PictureAsPdf />}
              sx={{ 
                bgcolor: 'success.main',
                '&:hover': {
                  bgcolor: 'success.dark',
                },
                ml: 'auto'
              }}
            >
              {fetchingFile ? <CircularProgress size={24} /> : "VIEW Plan"}
            </Button>
          </Box>
        </Grid>

        {/* Detail Plan View */}
        {showDetail && (
          <Grid item xs={12}>
            <DetailPlanView permitRequestNumber={permit_no} />
          </Grid>
        )}

        {/* Others Comments Section */}
        {showOthersComment && (
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Typography 
                variant="body2" 
                gutterBottom
                sx={{ 
                  color: '#000000',
                  fontWeight: 600,
                  fontFamily: '"Times New Roman", Times, serif'
                }}
              >
                Comments from Other Experts
              </Typography>
              {renderOthersCommentsTable()}
            </Box>
          </Grid>
        )}

        {/* Comment Input Section */}
        

        {/* Toast Message */}
        {toastMessage.message && (
          <Grid item xs={12}>
            <IPDCToastMessageResult 
              message={toastMessage.message} 
              type={toastMessage.type} 
            />
          </Grid>
        )}
      </Grid>
      {/* Description field from code 2 */}
      <Grid item xs={12} md={12}>
        <FormControl fullWidth={true}>
          <TextField
            rows={3}
            name="description"
            id="description"
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormControl>
      </Grid>
      {/* PDF Preview Modal */}
      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            height: '90vh',
            maxHeight: '90vh'
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center" gap={1}>
              <PictureAsPdf color="error" />
              <Typography variant="h6">
                PDF Preview: {fileInfo?.name}
              </Typography>
            </Box>
            <IconButton onClick={handleCloseModal} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0, height: 'calc(100% - 80px)' }}>
          {fetchingFile ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <CircularProgress />
            </Box>
          ) : (
            renderPDFViewer()
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Close</Button>
          <Button 
            onClick={handleDownloadPlan} 
            variant="contained" 
            startIcon={<Download />}
          >
            Download PDF
          </Button>
        </DialogActions>
      </Dialog>
    </FormContainer>
  );
}